import { Component } from '@angular/core';
import { CommonAPIService, CommonService, SharedService } from '../../../services';
import { NavigationEnd, Router } from '@angular/router';
import { filter, Subscription } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
@Component({
  selector: 'app-events',
  standalone: false,
  templateUrl: './events.component.html',
  styleUrl: './events.component.scss'
})
export class EventsComponent {
  routerSubscription!: Subscription;
  currentTab: number | null = null;
  galleryTabs: any[] = [];
  galleryCategoryData: any;
  getActiveGalleryData: any[] = [];
  imageUrl: string = environment.imageURL;
  popupImage: string | null = null;
  currentIndex: number = 0;
  photos: any[] = [];
  currentPhotos: any[] = [];

  constructor(
    private sharedService: SharedService,
    private commonService: CommonService,
    private commonAPIService: CommonAPIService,
    private router: Router,
    private http: HttpClient
  ) {
    this.routerSubscription = this.router.events.subscribe((event) => {
      if (router.url == '/events') {
        this.ngOnInit();
      }
    });
  }

  ngOnInit() {
    this.loadCategoryData();
  }

  openImagePopup(photos: any[], index: number) {
    this.currentPhotos = photos;
    this.currentIndex = index;
    this.popupImage = this.imageUrl + photos[index].photoPath;
  }

  closePopup() {
    this.popupImage = null;
  }

  loadCategoryData() {
    const getCategoryData = this.commonAPIService.data;
    if (getCategoryData) {
      this.galleryCategoryData = getCategoryData;
      this.getGalleryData();
    }
  }

  nextImage() {
    if (this.currentPhotos.length > 0) {
      this.currentIndex = (this.currentIndex + 1) % this.currentPhotos.length;
      this.popupImage =
        this.imageUrl + this.currentPhotos[this.currentIndex].photoPath;
    }
  }

  prevImage() {
    if (this.currentPhotos.length > 0) {
      this.currentIndex =
        (this.currentIndex - 1 + this.currentPhotos.length) %
        this.currentPhotos.length;
      this.popupImage =
        this.imageUrl + this.currentPhotos[this.currentIndex].photoPath;
    }
  }

  switchTab(tabId: number) {
    this.currentTab = tabId;
  }

  async getGalleryData() {
    this.getActiveGalleryData = [];
    const headers = new HttpHeaders({
      Authorization: 'Bearer QW5UaW1BdXRvd2FyZTpjaGF0Zm9yZGdl'
    });
    try {
      this.sharedService.setApiCall(true);
      this.commonService.resetAPIFlag('getCategoryWisegallery', false);
      // const response: any = await this.commonAPIService.getCall('getCategoryWisegallery', this.galleryCategoryData.galleryCategoryId);
      const response: any = await this.http
        .get(`${environment.baseURL}gallery/GalleryByCategoryId/${this.galleryCategoryData.galleryCategoryId}`, { headers })
        .toPromise();
      this.commonService.resetAPIFlag('getCategoryWisegallery', false);
      if (response?.gallery?.length) {
        const activeGalleries = response.gallery.filter((item: any) => item.isActive);
        this.galleryTabs = activeGalleries.map((item: any) => {
          let mediaArray: any[] = [];
          try {
            const parsed = typeof item.mediaPath === 'string'
              ? JSON.parse(item.mediaPath)
              : item.mediaPath;
            mediaArray = Array.isArray(parsed) ? parsed : Object.values(parsed);
          } catch (err) {
            console.error(`Invalid mediaPath for galleryId ${item.galleryId}:`, err);
          }
          return {
            galleryId: item.galleryId,
            galleryType: item.galleryType,
            galleryDiscription: item.galleryDiscription,
            photos: mediaArray.map((m: any) => ({
              photoPath: m.photoPath
            }))
          };
        });
        if (this.galleryTabs.length > 0) {
          this.currentTab = this.galleryTabs[0].galleryId;
        }
        this.sharedService.setApiCall(false);
      }
    } catch (error) {
      this.sharedService.setApiCall(false);
      console.error('Error fetching galleries:', error);
    }
  }

  ngOnDestroy(): void {
    if (this.routerSubscription) {
      this.routerSubscription.unsubscribe();
    }
  }

}
